import React from "react";

const SupplyChainIcon = React.forwardRef(
  (
    {
      width = "20",
      height = "20",
      viewBox = "0 0 20 20",
      fill = "none",
      strokeColor = "#344054",
      filColor = "white",
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 2.5H2.5M17.5 17.5H2.5M4.16667 10C4.16667 9.22343 4.16667 8.83515 4.29353 8.52886C4.46269 8.12048 4.78715 7.79602 5.19553 7.62687C5.50181 7.5 5.8901 7.5 6.66667 7.5L13.3333 7.5C14.1099 7.5 14.4982 7.5 14.8045 7.62687C15.2129 7.79602 15.5373 8.12048 15.7065 8.52886C15.8333 8.83515 15.8333 9.22343 15.8333 10C15.8333 10.7766 15.8333 11.1649 15.7065 11.4711C15.5373 11.8795 15.2129 12.204 14.8045 12.3731C14.4982 12.5 14.1099 12.5 13.3333 12.5L6.66667 12.5C5.8901 12.5 5.50181 12.5 5.19553 12.3731C4.78715 12.204 4.46269 11.8795 4.29353 11.4711C4.16667 11.1649 4.16667 10.7766 4.16667 10Z"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

SupplyChainIcon.displayName = "SupplyChainIcon";

export default SupplyChainIcon;
